import styled from 'styled-components'

export const ChartWrapper = styled.div`
  position: relative;
  width: 100%;
  padding: ${(props) => (props.theme.isMobile ? '1rem 0' : '2rem 2rem 1rem 2rem')};
  height: 100%;
`
